<template>
  <div class="sem-acesso-container d-flex justify-content-center align-items-center py-5">
    <div class="card text-center shadow-sm border-0" style="max-width: 480px; width: 100%;">
      <div class="card-body py-5 px-4">
        <div class="display-1 text-muted mb-4">
          <i class="bi bi-lock-fill"></i>
        </div>
        <h3 class="fw-bold mb-3">Acesso Restrito</h3>
        <p class="text-muted mb-1">
          Você não tem permissão para acessar o módulo
        </p>
        <p class="fw-bold text-danger-emphasis fs-5 mb-3">
          {{ titulo }}
        </p>
        <p class="text-muted small mb-0">
          <i class="bi bi-info-circle me-1"></i>
          Entre em contato com o administrador do sistema para solicitar acesso.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  titulo: {
    type: String,
    required: true
  }
})
</script>
